<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
      <div class="fw-bold w-auto my-0 lh-base h5" >需求列表 / 全部</div>
      <button @click="openAnnounceAchi"  class="btn btn-sm btn-primary me-1 flex-shrink-0" type="button"><i class="bi bi-send-fill me-1"></i>发布需求</button>
    </div>
    <div class="row g-2  border-bottom py-2 px-1">
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele1">所在区域：</label>
        <select v-model="params.region_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele1" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of region" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele2">需求类型：</label>
        <select v-model="params.demand_category_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele2" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of demand_category" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele3">获取方式：</label>
        <select v-model="params.obtain_way_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele3" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of obtain_way" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele4">意向合作单位：</label>
        <select v-model="params.company_category_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele4" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of company_category" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-3 d-flex align-items-baseline">
        <label class="small text-secondary flex-shrink-0" for="sele5">预算价格：</label>
        <select v-model="params.price_range_id" @change="getList(true)" class="form-select form-select-sm  rounded-0  ms-1 mt-1" id="sele5" aria-label="请选择" >
          <option value="">全部</option>
          <option v-for="item of price_range" :value="item.ID" :key="item.ID">{{item.Name}}</option>
        </select>
      </div>
      <div class="col  col-6 col-lg-4 col-xl-4 d-flex align-items-baseline">
        <input v-model="params.keyword" class="form-control form-control-sm  ms-1 mt-1 "  placeholder="请输入关键词">
          <a class="btn btn-sm btn-outline-primary flex-shrink-0 small ms-2"  @click="getList(true)">搜索</a>
      </div>
    </div>
    <!--没有数据-->
    <NodataCom :show="showNodata"></NodataCom>
    <!--  正在加载-->
    <LoadingCom :show="showLoading"></LoadingCom>
    <!--    列表-->
    <div class="p-2 list-box border-bottom" v-for="(item,index) of list" :key="index">
      <div class="p-2">
        <div class="d-flex align-content-center justify-content-between  rounded-2 mb-2">
          <div class=" w-auto my-0 lh-base " >
            <div class="fw-bold title-left me-3 point-curser" @click="goto(item)">{{item.Title}}</div>
          </div>
<!--          <span class="small fw-bold text-danger px-2 flex-shrink-0" v-if="item.statue===1">预算价格：100万</span>-->
<!--          <span class=" small fw-bold text-danger px-2 flex-shrink-0" v-else>预算价格：面议</span>-->
          <span class="badge title-badge badge-little-yellow rounded-pill px-2 flex-shrink-0 pub-one-row" v-if="item.Price!=-1">{{item.formattedAmount || 0}}</span>
          <span class="badge title-badge badge-little-yellow rounded-pill px-2 flex-shrink-0 pub-one-row" v-if="item.Price==-1">面议</span>
          <!--          <span class="badge title-badge text-bg-primary rounded-pill px-2 flex-shrink-0" v-if="item.statue===0">审核中</span>-->
          <!--          <span class="badge title-badge badge-little-green rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===1">已有小样</span>-->
          <!--          <span class="badge title-badge text-bg-warning text-white rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===2">已撤回</span>-->
          <!--          <span class="badge title-badge text-bg-danger rounded-pill px-2 flex-shrink-0" v-else-if="item.statue===3">已未通过</span>-->
        </div>
        <div class="d-flex align-items-center flex-wrap ">
          <div class="py-1 me-2">
            <small class="small me-3 text-body-secondary mb-1">发布时间：{{item.CreatedAtdeal}}</small>
          </div>
          <div class="py-1">
            <small class="small me-3 text-body-secondary mb-1">发布单位：{{item.Company }}</small>
          </div>
        </div>
      </div>
    </div>

  </div>
  <PaginationCom
      @pageChange="pageChangeFun($event)"
      :totalIn="total"
      :currentIn="params.current"
      :pageSizeIn="params.pageSize"
  ></PaginationCom>
  <!--   发布需求-->
<!--  <AnnounceAchievementsModel  v-model:show="showAnnounceAchievementsModel" ></AnnounceAchievementsModel>-->
  <!--没有数据-->
<!--  <NodataCom :show="showNodata"></NodataCom>-->
<!--  &lt;!&ndash;  正在加载&ndash;&gt;-->
<!--  <LoadingCom :show="showLoading"></LoadingCom>-->
</template>

<script setup>
// import AnnounceAchievementsModel from "@/components/AnnounceAchievementsModel"
import NodataCom from "@/layout/NodataCom"
import LoadingCom from "@/layout/LoadingCom"
import {computed, defineProps, onMounted, reactive, ref, watch} from "vue";
import router from "@/router";
import {getDemands} from "@/api/Demand";
import {formatTime} from "@/utils/dateFun";
import {showToast} from "@/utils/toast";
import store from "@/store";
// 获取筛选项
const region = computed(()=>store.state.dictModel.region) //所在区域
const demand_category = computed(()=>store.state.dictModel.demand_category) //需求类型
const obtain_way = computed(()=>store.state.dictModel.obtain_way) //获取方式
const company_category = computed(()=>store.state.dictModel.company_category) //意向合作单位
const price_range = computed(()=>store.state.dictModel.price_range) //价格范围
const login = computed(()=>store.state.loginModel.login) //是否登录
const params = reactive({
  keyword:"",//搜索关键词
  domain_id:"",//领域 ID,从父组件传入
  region_id:"",//区域 ID
  demand_category_id:"",//需求类型 ID
  obtain_way_id:"",//获取方式 ID
  company_category_id:"",//意向合作单位  ID
  price_range_id:"",//价格范围  ID
  current:1,
  pageSize:10,
})
const total  = ref(0)
// 发布需求
const openAnnounceAchi = ()=>{
  // showAnnounceAchievementsModel.value = true
  router.push({path:"/demmandadd"})
}
const list = ref({})
const showNodata = ref(false)
const showLoading = ref(false)
const props = defineProps({
  lyKey: {
    default: "", // 领域id
  }
})
watch(()=>props.lyKey,(n,o)=>{
  if(n){
    getList && getList(true)
  }else{
    getList && getList(true)
  }
})
onMounted(()=>{
  getList()
})
const pageChangeFun = (e)=>{
  params.current = e.page
  params.pageSize = e.pageSize
  getList()
}
// 获取消息列表
const getList = async (currentinit)=>{
  if(currentinit){
    params.current = 1
  }
  showLoading.value = true
  showNodata.value = false
  list.value = []
  total.value = 0
  params.domain_id = props.lyKey
  const res =await  getDemands(params)
  showLoading.value = false
  if(res.err_code==0){
    const data =  res.data || []
    data.forEach(item=>{
      if(item.CreatedAt){0
        item.CreatedAtdeal = formatTime(item.CreatedAt)
      }
      if(item.Price!==-1){
        const formattedAmount = new Intl.NumberFormat('zh-CN', {
          style: 'currency',
          currency: 'CNY',
        }).format(item.Price);
        item.formattedAmount = formattedAmount
      }
      // ch.InstitutionName = ch.Institution.Name
      // // 预约方式
      // if(ch.Mode==1){
      //   ch.modeName = "自主上机"
      // }else if(ch.Mode==2){
      //   ch.modeName = "送样检测"
      // }else{
      //   ch.modeName = "自主上机/送样检测"
      // }
    })
    list.value = data
    total.value = res.total || 0
    if(data.length<=0){
      showNodata.value = true
    }
  }else{
    showToast("danger",res.err_msg || "请求出错")
  }
}
// 跳转
const goto = (item) => {
  router.push({path:'/demmandDetail',query:{id:item.ID}})
}
</script>

<style scoped lang="scss">

.title-left{
  word-break: break-all;
}
.title-badge{
  height: 1.5rem;
  line-height: 1rem;
  font-size: 0.7rem;
  font-weight: normal;
  //min-width: 3rem;
  width: 6rem;
  text-align: center;
}
.small{
  font-size: 0.9rem;
}
.list-box{
  box-sizing: border-box;
}

.small-btn-size{
  height: 1.5rem;
  line-height: 1rem;
}

.btn-check + .btn{
  border: none;
}
.btn-check:checked + .btn{
  color: #0d6efd;
}
//sm: 540px,
//md: 720px,
//lg: 960px,
// xl: 1140px,
// xxl: 1320px
.tabs-box{
  box-sizing: border-box;
  justify-content: space-between !important;
  @media (min-width: 1400px){
    justify-content: start !important;
  }
}
.form-item-box{
  width: 48.5% !important;
  box-sizing: border-box;
  @media (min-width: 576px){
    width: 48.5% !important;
  }
  @media (min-width: 768px){
    width: 32.33% !important;
  }
  @media (min-width: 992px){
    width: 32.33% !important;
  }
  @media (min-width: 1200px){
    width: 32.33% !important;
  }
  @media (min-width: 1400px){
    width: 16% !important;
    min-width: 120px;
    max-width: 200px;
  }
}

</style>
